import { Injectable, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { combineLatest, Observable } from 'rxjs'
import { Interval } from '@elderbyte/ngx-starter'
import { debounceTime, map } from 'rxjs/operators'
import { Facility } from '../facilities/facility'
import { IntervalContextService } from './interval-context/interval-context.service'
import { FacilityContextService } from './facility-context/facility-context.service'
import { MexusViewMode } from './view-mode-context/mexus-view-mode'
import { ViewModeContextService } from './view-mode-context/view-mode-context.service'
import { LiveTimestampService } from './live-timestamp-context/live-timestamp.service'
import { Instant } from '@js-joda/core'

export class MexusContext {
  constructor(
    public readonly facility: Facility,
    public readonly interval: Interval,
    public readonly viewMode: MexusViewMode,
    public readonly liveTimestamp: Instant
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class MexusContextService {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _activeContext: Observable<MexusContext>
  private intervalContextService = inject(IntervalContextService)
  private facilityContextService = inject(FacilityContextService)
  private viewModeContextService = inject(ViewModeContextService)
  private liveTimestampService = inject(LiveTimestampService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this._activeContext = combineLatest([
      this.facilityContextService.facility$,
      this.intervalContextService.interval$,
      this.viewModeContextService.viewMode$,
      this.liveTimestampService.timestamp$,
    ]).pipe(
      debounceTime(50),
      map(
        ([facility, interval, viewMode, liveTimestamp]) =>
          new MexusContext(facility, interval, viewMode, liveTimestamp)
      )
    )
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get activeContext$(): Observable<MexusContext> {
    return this._activeContext
  }
}
